import React from 'react';
// import styled from "styled-components";
import { NoHeaderLayout } from 'src/components/layouts/DefaultLayout';
import SpinnerModal from 'src/components/organisms/loading/SpinnerModal';
import StyleConfig from 'src/constants/StyleConfig';

const LoadingContainer = () => {
  return (
    <NoHeaderLayout>
      <SpinnerModal isLoading color={StyleConfig.COLOR.PRIMARY} />
    </NoHeaderLayout>
  );
};

export default LoadingContainer;
